module.exports = __webpack_public_path__ + "img/LogoEmblem.69e48c76.png";